import { FormArray, FormControl, FormGroup } from '@angular/forms';

export class ReactiveFormUtils {

	/**
	 * Initial point to get all the errors in a ReactiveForm
	 *
	 * @param form: FormGroup
	 * @returns
	 */
	public static getErrorList(form: FormGroup): any[] {
		const errors = [];
		ReactiveFormUtils.collectErrorsFromForm(form, [], [], errors);

		return errors;
	}

	/**
	 * Run through the formGroup and collect all the Errors
	 *
	 * @param c: FormGroup | FormControl | FormArray
	 * @param path
	 * @param customPath
	 * @param errors
	 */
	public static collectErrorsFromForm(c: any, path: string[], customPath: string[], errors: any[]): void {
		for (const key in c.controls) {
			// eslint-disable-next-line no-prototype-builtins
			if (c.controls.hasOwnProperty(key)) {
				const control = c.get(key);
				const levelNumberValue = '';
				const _customPath = path.length > 1 && path[path.length - 2] === 'levels' && levelNumberValue !== '' ?
					[...path.slice(0, path.length - 1), levelNumberValue] :
					customPath;

				if (control instanceof FormGroup || control instanceof FormArray) {
					if (control.errors !== null) {
						errors.push({
							key,
							path,
							customPath: _customPath,
							uiPath: [],
							jsonPath: [...path, key].join('.'),
							error: control.errors
						});
					}

					ReactiveFormUtils.collectErrorsFromForm(
						control,
						[...path, key],
						[..._customPath, key],
						errors
					);

				} else {
					if (control.errors !== null) {
						errors.push({
							key,
							path,
							customPath: _customPath,
							uiPath: [],
							jsonPath: [...path, key].join('.'),
							error: control.errors,
						});
					}
				}
			}
		}
	}

	/**
	 * Get FormControl|FormGrup from a reactiveFrom given a path
	 * @param form
	 * @param pathToFind
	 * @returns
	 */
	public static getFormControl(form: FormGroup, pathToFind: string): FormControl | FormGroup  {
		let formData: any = form;

		pathToFind.split('.').forEach(path => {
			const pathPattern = /(\[[0-9]+\])/g;
			const matches = path.match(pathPattern);
			let isArray = false;
			let pathIndex;

			if (matches) {
				isArray = true;
				// eslint-disable-next-line
				pathIndex = matches[0].replace(/([\[\]])/g, '');
				path = path.replace(pathPattern, '');
			}

			formData = formData.get(path);
			if (isArray) {
				formData = formData.at(pathIndex);
			}
		});

		return formData;
	}

	/**
	 * Recursive function that genereates the Dirty-only object & the updated full path object.
	 * After getting the "field", the function mark the field as pristine.
	 *
	 * @param formItem FormGroup | FormArray | FormControl
	 * @param updatedValuesObject Any writable object {}
	 * @param updatedPaths Any writable object {}
	 * @param formControlNamesPassthrough Array of String name of the formControls to be excluded
	 * @param name formcontrolName
	 * @param trailingPath Path of the read object
	 * @param passthrough Flag to tell the function to print the object instead of deep read it
	 */
	public static getFormUpdatedPaths(
		formItem: FormGroup | FormArray | FormControl,
		updatedValuesObject: any,
		updatedPaths: any,
		formControlNamesPassthrough: string[],
		name?: string,
		trailingPath?: string,
		passthrough?: boolean
	): void {
		if (formItem instanceof FormControl || passthrough) {
			if ((name && formItem.dirty) || passthrough) {
				updatedValuesObject[name] = formItem.value;
				updatedPaths[`${trailingPath}${name}`] = formItem.value;
				formItem.markAsPristine();
			}
		} else {
			for (const formControlName in formItem.controls) {
				if (Object.prototype.hasOwnProperty.call(formItem.controls, formControlName)) {
					const formControl = formItem.controls[formControlName];
					let nPath = '';
					if (trailingPath) {
						nPath = `${trailingPath}.`;
					}

					if (formControl instanceof FormControl) {
						ReactiveFormUtils.getFormUpdatedPaths(formControl, updatedValuesObject, updatedPaths, formControlNamesPassthrough, formControlName, nPath);

					} else if (
						formControl instanceof FormArray &&
						formControl.dirty &&
						formControl.controls.length > 0
					) {
						let pass = false;
						if (formControlNamesPassthrough.indexOf(formControlName) > -1) {
							pass = true;
						} else {
							nPath = `${nPath}${formControlName}`;
						}

						updatedValuesObject[formControlName] = [];
						ReactiveFormUtils.getFormUpdatedPaths(formControl, updatedValuesObject[formControlName], updatedPaths, formControlNamesPassthrough, formControlName, nPath, pass);

					} else if (formControl instanceof FormGroup && formControl.dirty) {
						if (isNaN(parseInt(formControlName))) {
							nPath = `${nPath}${formControlName}`;
						} else {
							nPath = `${nPath}[${formControlName}]`;
							nPath = nPath.replace('.[', '[');
						}
						updatedValuesObject[formControlName] = {};
						ReactiveFormUtils.getFormUpdatedPaths(formControl, updatedValuesObject[formControlName], updatedPaths, formControlNamesPassthrough, null, nPath);
					}
				}
			}
		}
	}
}
